import { apiSlice } from '../api/apiSlice';
import {
  AuthParams,
  AuthResponse,
  ForgotPasswordParams,
  MessageResponse,
  SignUpParams,
  ResetPasswordParams,
} from './userApiTypes';

const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loginUser: builder.mutation<AuthResponse, AuthParams>({
      query: ({ email, password }) => ({
        url: `/auth/login`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: {
          email,
          password,
        },
      }),
    }),

    signUp: builder.mutation<MessageResponse, SignUpParams>({
      query: (data) => ({
        url: `/auth/register`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: {
          email: data.email,
          password: data.password,
          fullName: data.fullName,
          referralCode: data.referralCode,
          clientType: data.clientType,
        },
      }),
    }),

    forgotPassword: builder.mutation<MessageResponse, ForgotPasswordParams>({
      query: ({ email }) => ({
        url: `/auth/forgot-password`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: {
          email,
        },
      }),
    }),

    logoutUser: builder.mutation<MessageResponse, void>({
      query: () => ({
        url: `/auth/logout`,
        method: 'POST',
      }),
    }),
    resendVerification: builder.mutation<MessageResponse, { email: string; clientType?: 'web' | 'mobile' }>({
      query: (data) => ({
        url: `/auth/resend-verification`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: {
          email: data.email,
          clientType: data.clientType || 'web',
        },
      }),
    }),
    resetPassword: builder.mutation<MessageResponse, ResetPasswordParams>({
      query: ({ token, newPassword }) => ({
        url: `/auth/reset-password`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: {
          token,
          newPassword,
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoginUserMutation,
  useSignUpMutation,
  useForgotPasswordMutation,
  useLogoutUserMutation,
  useResendVerificationMutation,
  useResetPasswordMutation,
} = userApiSlice;
